//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IAuthClient {

    authenticate2FA(model: LoginRequest): Promise<LoginResponse>;

    authenticate(model: LoginRequest): Promise<LoginResponse>;

    authenticateEx(model: LoginRequest): Promise<LoginResponseEx>;

    logout(): Promise<BaseResponse>;

    getUser(): Promise<CurrentUser>;

    register(): Promise<BaseResponse>;

    resetPassword(model: PasswordResetRequest): Promise<PasswordResetResponse>;

    forgotPassword(model: ForgotPasswordRequest): Promise<ForgotPasswordResponse>;
}

export class AuthClient implements IAuthClient {
    private http: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>};
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5003";
    }

    authenticate2FA(model: LoginRequest): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/Auth/Authenticate2FA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate2FA(_response);
        });
    }

    protected processAuthenticate2FA(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoginResponse.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    authenticate(model: LoginRequest): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/Auth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoginResponse.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    authenticateEx(model: LoginRequest): Promise<LoginResponseEx> {
        let url_ = this.baseUrl + "/api/Auth/AuthenticateEx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticateEx(_response);
        });
    }

    protected processAuthenticateEx(response: Response): Promise<LoginResponseEx> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoginResponseEx.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponseEx>(null as any);
    }

    logout(): Promise<BaseResponse> {
        let url_ = this.baseUrl + "/api/Auth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BaseResponse.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponse>(null as any);
    }

    getUser(): Promise<CurrentUser> {
        let url_ = this.baseUrl + "/api/Auth/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<CurrentUser> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CurrentUser.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentUser>(null as any);
    }

    register(): Promise<BaseResponse> {
        let url_ = this.baseUrl + "/api/Auth/Register";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BaseResponse.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponse>(null as any);
    }

    resetPassword(model: PasswordResetRequest): Promise<PasswordResetResponse> {
        let url_ = this.baseUrl + "/api/Auth/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<PasswordResetResponse> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PasswordResetResponse.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PasswordResetResponse>(null as any);
    }

    forgotPassword(model: ForgotPasswordRequest): Promise<ForgotPasswordResponse> {
        let url_ = this.baseUrl + "/api/Auth/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<ForgotPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ForgotPasswordResponse.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForgotPasswordResponse>(null as any);
    }
}

export interface IBBApiClient {

    get(): Promise<MarketCapInfo[]>;

    getQuotes(symbols: string[]): Promise<QuoteData[]>;

    fixQuotesAll(): Promise<QuoteData[]>;

    getSymbols(withOpen?: boolean | undefined): Promise<string[]>;

    getTiingoSymbols(): Promise<TickerMetadata[]>;

    getSymbolsMetadata(): Promise<TickerMetadata[]>;

    getSymbolHistorySimple(symbol?: string | undefined): Promise<HistoryResponse>;

    getSymbolMiniChartData(symbol?: string | undefined): Promise<MiniChartData>;
}

export class BBApiClient implements IBBApiClient {
    private http: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>};
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5003";
    }

    get(): Promise<MarketCapInfo[]> {
        let url_ = this.baseUrl + "/BBApi/GetMarketCap";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MarketCapInfo[]> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if(Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for(let item of resultData200)
                        result200!.push(MarketCapInfo.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketCapInfo[]>(null as any);
    }

    getQuotes(symbols: string[]): Promise<QuoteData[]> {
        let url_ = this.baseUrl + "/BBApi/GetQuotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(symbols);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuotes(_response);
        });
    }

    protected processGetQuotes(response: Response): Promise<QuoteData[]> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if(Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for(let item of resultData200)
                        result200!.push(QuoteData.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuoteData[]>(null as any);
    }

    fixQuotesAll(): Promise<QuoteData[]> {
        let url_ = this.baseUrl + "/BBApi/FixQuotesAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFixQuotesAll(_response);
        });
    }

    protected processFixQuotesAll(response: Response): Promise<QuoteData[]> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if(Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for(let item of resultData200)
                        result200!.push(QuoteData.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuoteData[]>(null as any);
    }

    getSymbols(withOpen?: boolean | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/BBApi/GetSymbols?";
        if(withOpen === null)
            throw new Error("The parameter 'withOpen' cannot be null.");
        else if(withOpen !== undefined)
            url_ += "withOpen=" + encodeURIComponent("" + withOpen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSymbols(_response);
        });
    }

    protected processGetSymbols(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if(Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for(let item of resultData200)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getTiingoSymbols(): Promise<TickerMetadata[]> {
        let url_ = this.baseUrl + "/BBApi/GetTiingoSymbols";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTiingoSymbols(_response);
        });
    }

    protected processGetTiingoSymbols(response: Response): Promise<TickerMetadata[]> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if(Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for(let item of resultData200)
                        result200!.push(TickerMetadata.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TickerMetadata[]>(null as any);
    }

    getSymbolsMetadata(): Promise<TickerMetadata[]> {
        let url_ = this.baseUrl + "/BBApi/GetSymbolsMetadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSymbolsMetadata(_response);
        });
    }

    protected processGetSymbolsMetadata(response: Response): Promise<TickerMetadata[]> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if(Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for(let item of resultData200)
                        result200!.push(TickerMetadata.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TickerMetadata[]>(null as any);
    }

    getSymbolHistorySimple(symbol?: string | undefined): Promise<HistoryResponse> {
        let url_ = this.baseUrl + "/BBApi/GetSymbolHistorySimple?";
        if(symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if(symbol !== undefined)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSymbolHistorySimple(_response);
        });
    }

    protected processGetSymbolHistorySimple(response: Response): Promise<HistoryResponse> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = HistoryResponse.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoryResponse>(null as any);
    }

    getSymbolMiniChartData(symbol?: string | undefined, range?: string | undefined, interval?: string | undefined): Promise<MiniChartData> {
        let url_ = this.baseUrl + "/BBApi/GetSymbolMiniChartData?";
        if(symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if(symbol !== undefined)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        if (range) {
            url_ += `&range=${range.toLowerCase()}`;
        }

        if (interval) {
            url_ += `&interval=${interval.toLowerCase()}`;
        }

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSymbolMiniChartData(_response);
        });
    }

    protected processGetSymbolMiniChartData(response: Response): Promise<MiniChartData> {
        const status = response.status;
        let _headers: any = {}; if(response.headers && response.headers.forEach) {response.headers.forEach((v: any, k: any) => _headers[k] = v);};
        if(status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MiniChartData.fromJS(resultData200);
                return result200;
            });
        } else if(status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiniChartData>(null as any);
    }
}

export abstract class BaseResponse implements IBaseResponse {
    wanings!: string[];
    errors!: string[];
    isSuccess!: boolean;
    message?: string | undefined;

    constructor(data?: IBaseResponse) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if(!data) {
            this.wanings = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if(_data) {
            if(Array.isArray(_data["wanings"])) {
                this.wanings = [] as any;
                for(let item of _data["wanings"])
                    this.wanings!.push(item);
            }
            if(Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for(let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BaseResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if(Array.isArray(this.wanings)) {
            data["wanings"] = [];
            for(let item of this.wanings)
                data["wanings"].push(item);
        }
        if(Array.isArray(this.errors)) {
            data["errors"] = [];
            for(let item of this.errors)
                data["errors"].push(item);
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IBaseResponse {
    wanings: string[];
    errors: string[];
    isSuccess: boolean;
    message?: string | undefined;
}

export class LoginResponse extends BaseResponse implements ILoginResponse {
    token!: string;
    authenticationType?: number | undefined;

    constructor(data?: ILoginResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if(_data) {
            this.token = _data["token"];
            this.authenticationType = _data["authenticationType"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["authenticationType"] = this.authenticationType;
        super.toJSON(data);
        return data;
    }
}

export interface ILoginResponse extends IBaseResponse {
    token: string;
    authenticationType?: number | undefined;
}

export abstract class BaseRequest implements IBaseRequest {

    constructor(data?: IBaseRequest) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseRequest {
}

export class LoginRequest extends BaseRequest implements ILoginRequest {
    login!: string;
    password!: string;
    rememberMe!: boolean;

    constructor(data?: ILoginRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if(_data) {
            this.login = _data["login"];
            this.password = _data["password"];
            this.rememberMe = _data["rememberMe"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        super.toJSON(data);
        return data;
    }
}

export interface ILoginRequest extends IBaseRequest {
    login: string;
    password: string;
    rememberMe: boolean;
}

export class LoginResponseEx extends LoginResponse implements ILoginResponseEx {
    claimValues!: ClaimValue[];

    constructor(data?: ILoginResponseEx) {
        super(data);
        if(!data) {
            this.claimValues = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if(_data) {
            if(Array.isArray(_data["claimValues"])) {
                this.claimValues = [] as any;
                for(let item of _data["claimValues"])
                    this.claimValues!.push(ClaimValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoginResponseEx {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseEx();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if(Array.isArray(this.claimValues)) {
            data["claimValues"] = [];
            for(let item of this.claimValues)
                data["claimValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILoginResponseEx extends ILoginResponse {
    claimValues: ClaimValue[];
}

export class ClaimValue implements IClaimValue {
    name!: string;
    value!: string;

    constructor(data?: IClaimValue) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ClaimValue {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IClaimValue {
    name: string;
    value: string;
}

export class CurrentUser extends BaseResponse implements ICurrentUser {
    isAuthenticated!: boolean;
    userName!: string;
    role!: string;
    claims!: {[key: string]: string;};

    constructor(data?: ICurrentUser) {
        super(data);
        if(!data) {
            this.claims = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if(_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.userName = _data["userName"];
            this.role = _data["role"];
            if(_data["claims"]) {
                this.claims = {} as any;
                for(let key in _data["claims"]) {
                    if(_data["claims"].hasOwnProperty(key))
                        (<any>this.claims)![key] = _data["claims"][key];
                }
            }
        }
    }

    static fromJS(data: any): CurrentUser {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["userName"] = this.userName;
        data["role"] = this.role;
        if(this.claims) {
            data["claims"] = {};
            for(let key in this.claims) {
                if(this.claims.hasOwnProperty(key))
                    (<any>data["claims"])[key] = (<any>this.claims)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICurrentUser extends IBaseResponse {
    isAuthenticated: boolean;
    userName: string;
    role: string;
    claims: {[key: string]: string;};
}

export class PasswordResetResponse extends BaseResponse implements IPasswordResetResponse {

    constructor(data?: IPasswordResetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PasswordResetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPasswordResetResponse extends IBaseResponse {
}

export class PasswordResetRequest extends BaseRequest implements IPasswordResetRequest {
    password!: string;
    passwordConfirmation!: string;
    resetKey!: string;

    constructor(data?: IPasswordResetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if(_data) {
            this.password = _data["password"];
            this.passwordConfirmation = _data["passwordConfirmation"];
            this.resetKey = _data["resetKey"];
        }
    }

    static fromJS(data: any): PasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["passwordConfirmation"] = this.passwordConfirmation;
        data["resetKey"] = this.resetKey;
        super.toJSON(data);
        return data;
    }
}

export interface IPasswordResetRequest extends IBaseRequest {
    password: string;
    passwordConfirmation: string;
    resetKey: string;
}

export class ForgotPasswordResponse extends BaseResponse implements IForgotPasswordResponse {

    constructor(data?: IForgotPasswordResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ForgotPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IForgotPasswordResponse extends IBaseResponse {
}

export class ForgotPasswordRequest extends BaseRequest implements IForgotPasswordRequest {
    usernameOrEmail!: string;

    constructor(data?: IForgotPasswordRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if(_data) {
            this.usernameOrEmail = _data["usernameOrEmail"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usernameOrEmail"] = this.usernameOrEmail;
        super.toJSON(data);
        return data;
    }
}

export interface IForgotPasswordRequest extends IBaseRequest {
    usernameOrEmail: string;
}

export class MarketCapInfo implements IMarketCapInfo {
    id!: number;
    name?: string | undefined;
    symbol?: string | undefined;
    category?: string | undefined;
    notice?: string | undefined;
    selfReportedCirculatingSupply?: number | undefined;
    selfReportedMarketCap?: number | undefined;
    date!: Date;
    icon?: string | undefined;
    description?: string | undefined;

    constructor(data?: IMarketCapInfo) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
            this.category = _data["category"];
            this.notice = _data["notice"];
            this.selfReportedCirculatingSupply = _data["selfReportedCirculatingSupply"];
            this.selfReportedMarketCap = _data["selfReportedMarketCap"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.icon = _data["icon"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MarketCapInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MarketCapInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        data["category"] = this.category;
        data["notice"] = this.notice;
        data["selfReportedCirculatingSupply"] = this.selfReportedCirculatingSupply;
        data["selfReportedMarketCap"] = this.selfReportedMarketCap;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["icon"] = this.icon;
        data["description"] = this.description;
        return data;
    }
}

export interface IMarketCapInfo {
    id: number;
    name?: string | undefined;
    symbol?: string | undefined;
    category?: string | undefined;
    notice?: string | undefined;
    selfReportedCirculatingSupply?: number | undefined;
    selfReportedMarketCap?: number | undefined;
    date: Date;
    icon?: string | undefined;
    description?: string | undefined;
}

export class QuoteData implements IQuoteData {
    qt!: QuoteDataType;
    s!: string;
    e!: string;
    ls?: number | undefined;
    lp!: number;
    bs?: number | undefined;
    bp?: number | undefined;
    as?: number | undefined;
    ap?: number | undefined;
    c?: number | undefined;
    o?: number | undefined;
    t!: Date;

    constructor(data?: IQuoteData) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.qt = _data["qt"];
            this.s = _data["s"];
            this.e = _data["e"];
            this.ls = _data["ls"];
            this.lp = _data["lp"];
            this.bs = _data["bs"];
            this.bp = _data["bp"];
            this.as = _data["as"];
            this.ap = _data["ap"];
            this.c = _data["c"];
            this.o = _data["o"];
            this.t = _data["t"] ? new Date(_data["t"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QuoteData {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qt"] = this.qt;
        data["s"] = this.s;
        data["e"] = this.e;
        data["ls"] = this.ls;
        data["lp"] = this.lp;
        data["bs"] = this.bs;
        data["bp"] = this.bp;
        data["as"] = this.as;
        data["ap"] = this.ap;
        data["c"] = this.c;
        data["o"] = this.o;
        data["t"] = this.t ? this.t.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQuoteData {
    qt: QuoteDataType;
    s: string;
    e: string;
    ls?: number | undefined;
    lp: number;
    bs?: number | undefined;
    bp?: number | undefined;
    as?: number | undefined;
    ap?: number | undefined;
    c?: number | undefined;
    o?: number | undefined;
    t: Date;
}

export enum QuoteDataType {
    Trade = 0,
    Quote = 1,
}

export class TickerMetadata implements ITickerMetadata {
    ticker?: string | undefined;
    baseCurrency?: string | undefined;
    name?: string | undefined;
    quoteCurrency?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITickerMetadata) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.ticker = _data["ticker"];
            this.baseCurrency = _data["baseCurrency"];
            this.name = _data["name"];
            this.quoteCurrency = _data["quoteCurrency"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TickerMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new TickerMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticker"] = this.ticker;
        data["baseCurrency"] = this.baseCurrency;
        data["name"] = this.name;
        data["quoteCurrency"] = this.quoteCurrency;
        data["description"] = this.description;
        return data;
    }
}

export interface ITickerMetadata {
    ticker?: string | undefined;
    baseCurrency?: string | undefined;
    name?: string | undefined;
    quoteCurrency?: string | undefined;
    description?: string | undefined;
}

export class HistoryResponse implements IHistoryResponse {
    ticker?: string | undefined;
    baseCurrency?: string | undefined;
    quoteCurrency?: string | undefined;
    priceData!: BarData[];

    constructor(data?: IHistoryResponse) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if(!data) {
            this.priceData = [];
        }
    }

    init(_data?: any) {
        if(_data) {
            this.ticker = _data["ticker"];
            this.baseCurrency = _data["baseCurrency"];
            this.quoteCurrency = _data["quoteCurrency"];
            if(Array.isArray(_data["priceData"])) {
                this.priceData = [] as any;
                for(let item of _data["priceData"])
                    this.priceData!.push(BarData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticker"] = this.ticker;
        data["baseCurrency"] = this.baseCurrency;
        data["quoteCurrency"] = this.quoteCurrency;
        if(Array.isArray(this.priceData)) {
            data["priceData"] = [];
            for(let item of this.priceData)
                data["priceData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHistoryResponse {
    ticker?: string | undefined;
    baseCurrency?: string | undefined;
    quoteCurrency?: string | undefined;
    priceData: BarData[];
}

export class BarData implements IBarData {
    open?: number | undefined;
    high?: number | undefined;
    low?: number | undefined;
    close?: number | undefined;
    date!: Date;
    tradesDone?: number | undefined;
    volume?: number | undefined;
    volumeNotional?: number | undefined;

    constructor(data?: IBarData) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.open = _data["open"];
            this.high = _data["high"];
            this.low = _data["low"];
            this.close = _data["close"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.tradesDone = _data["tradesDone"];
            this.volume = _data["volume"];
            this.volumeNotional = _data["volumeNotional"];
        }
    }

    static fromJS(data: any): BarData {
        data = typeof data === 'object' ? data : {};
        let result = new BarData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["open"] = this.open;
        data["high"] = this.high;
        data["low"] = this.low;
        data["close"] = this.close;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["tradesDone"] = this.tradesDone;
        data["volume"] = this.volume;
        data["volumeNotional"] = this.volumeNotional;
        return data;
    }
}

export interface IBarData {
    open?: number | undefined;
    high?: number | undefined;
    low?: number | undefined;
    close?: number | undefined;
    date: Date;
    tradesDone?: number | undefined;
    volume?: number | undefined;
    volumeNotional?: number | undefined;
}

export class MiniChartData implements IMiniChartData {
    id!: number;
    name?: string | undefined;
    symbol?: string | undefined;
    category?: string | undefined;
    notice?: string | undefined;
    icon?: string | undefined;
    description?: string | undefined;
    date!: Date;
    data!: HistoryResponse;
    q?: QuoteData | undefined;

    constructor(data?: IMiniChartData) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if(!data) {
            this.data = new HistoryResponse();
        }
    }

    init(_data?: any) {
        if(_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
            this.category = _data["category"];
            this.notice = _data["notice"];
            this.icon = _data["icon"];
            this.description = _data["description"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.data = _data["data"] ? HistoryResponse.fromJS(_data["data"]) : new HistoryResponse();
            this.q = _data["q"] ? QuoteData.fromJS(_data["q"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MiniChartData {
        data = typeof data === 'object' ? data : {};
        let result = new MiniChartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        data["category"] = this.category;
        data["notice"] = this.notice;
        data["icon"] = this.icon;
        data["description"] = this.description;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["q"] = this.q ? this.q.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMiniChartData {
    id: number;
    name?: string | undefined;
    symbol?: string | undefined;
    category?: string | undefined;
    notice?: string | undefined;
    icon?: string | undefined;
    description?: string | undefined;
    date: Date;
    data: HistoryResponse;
    q?: QuoteData | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: {[key: string]: any;};
    result: any;

    constructor(message: string, status: number, response: string, headers: {[key: string]: any;}, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: {[key: string]: any;}, result?: any): any {
    if(result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}